import {
    GETREFUNDPARTNER_SUCCESS,
    GETREFUNDPARTNER_FAILED,
    RESET_GETREFUNDPARTNER,
    // LOADING_GETREFUNDPARTNER,
    NETWORK_ERROR_GETREFUNDPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";


const resetGetRefunds = () => {
    return { type: RESET_GETREFUNDPARTNER };
};

const getRefunds = (userData, authTokenIs) => async (dispatch) => {
    // dispatch({ type: LOADING_GETREFUNDPARTNER });
    await partnerServices
        .post("refund", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(getRefundssuccess(res.data));
                    break;
                case "success":
                    dispatch(getRefundssuccess(res.data));
                    break;
                default:
                    dispatch(getRefundsFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETREFUNDPARTNER, payload: err });
        });
};
function getRefundssuccess(data) {
    return {
        type: GETREFUNDPARTNER_SUCCESS,
        payload: data,
    };
}
function getRefundsFailed(data) {
    return {
        type: GETREFUNDPARTNER_FAILED,
        payload: data,
    };
}

export { resetGetRefunds, getRefunds };
